import { useState } from 'react';
import { getInitials } from '@/components/primitives/getInitials.js';

/** An app's logo on a neutral tile; the app's initials while it loads or when it has none. Sizes: md, lg. */
const AppLogo = ({ app, size = 'md' }) => {
  const [failed, setFailed] = useState(false);
  const src = failed ? null : app?.icon || app?.appIcon || null;
  const name = app?.name || app?.appName || '';

  return (
    <span className={`comp-app-logo comp-app-logo--${size}`} aria-hidden="true">
      {src ? <img src={src} alt="" loading="lazy" onError={() => setFailed(true)} /> : <span className="comp-app-logo__initials">{getInitials(name)}</span>}
    </span>
  );
};

export default AppLogo;
